<template>
  <div class="mail-channel">
    <h3 v-if="heading">{{ heading }}</h3>
    <a v-if="contact" class="mail-addr" :href="'mailto:' + contact">{{ contact }}</a>
    <p v-if="lead" class="mail-lead">{{ lead }}</p>
    <ul v-if="checklist.length" class="mail-list">
      <li v-for="(line, i) in checklist" :key="i">{{ line }}</li>
    </ul>
    <pgp-meta />
  </div>
</template>
<script>
import { t } from '../i18n'
import { mapState, mapGetters } from 'vuex'
import PgpMeta from './PgpMeta.vue'

export default {
  name: 'mail-channel',
  components: { PgpMeta },
  computed: {
    ...mapState(['locale', 'brand', 'policy']),
    ...mapGetters(['policyText', 'policyLines']),
    contact() {
      return this.policy.securityContact || this.brand.securityContact || ''
    },
    heading() {
      return this.t('mailAlt')
    },
    lead() {
      return this.t('mailChecklistTitle')
    },
    checklist() {
      return this.policyLines('mailChecklist')
    }
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    }
  }
}
</script>
